import React from 'react';
import SearchIcon from '@mui/icons-material/Search';

import { AVAILABLE_YEARS, PLAYER_PAGE_SIZE_OPTIONS } from '../../pages/newResults/newResultsConstants';
import MultiSelectField from './MultiSelectField';
import { serializeMultiFilter } from '../../pages/newResults/newResultsNavigation';

export default function EquipesTabToolbar({
	state,
	zones,
	equipesChampionships,
	clubs,
	onPatchParams,
}) {
	return (
		<div className="new-results-toolbar">
			<div className="new-results-field">
				<label htmlFor="nr-eq-year">Saison</label>
				<select
					id="nr-eq-year"
					value={state.year}
					onChange={(e) => onPatchParams({ year: e.target.value })}
				>
					{AVAILABLE_YEARS.map((y) => (
						<option key={y} value={y}>{y}</option>
					))}
				</select>
			</div>
			<div className="new-results-field">
				<label htmlFor="nr-eq-zone">Zone</label>
				<select
					id="nr-eq-zone"
					value={state.equipesZone}
					onChange={(e) => onPatchParams({
						eqZone: e.target.value || null,
						cat: null,
						club: null,
						team: null,
					})}
				>
					<option value="">Toutes</option>
					{zones.map((z) => (
						<option key={z} value={z}>{z}</option>
					))}
				</select>
			</div>
			<div className="new-results-field">
				<label htmlFor="nr-eq-champ">Championnat</label>
				<select
					id="nr-eq-champ"
					value={state.equipesCategory}
					onChange={(e) => onPatchParams({
						cat: e.target.value || null,
						team: null,
					})}
				>
					<option value="">Toutes</option>
					{equipesChampionships.map((c) => (
						<option key={c} value={c}>{c}</option>
					))}
				</select>
			</div>
			<div className="new-results-field">
				<label htmlFor="nr-eq-club">Club</label>
				<select
					id="nr-eq-club"
					value={state.club}
					onChange={(e) => onPatchParams({ club: e.target.value || null })}
				>
					<option value="">Tous</option>
					{clubs.map((c) => (
						<option key={c} value={c}>{c}</option>
					))}
				</select>
			</div>
		</div>
	);
}

export function JoueursTabToolbar({
	state,
	localSearch,
	onLocalSearchChange,
	playerLicenceCategories,
	playerLicenceTypes,
	playerClubs,
	minManchesOptions,
	effectivePlayerPage,
	totalPlayerPages,
	onPatchParams,
}) {
	return (
		<>
			<div className="new-results-toolbar">
				<div className="new-results-field">
					<label htmlFor="nr-j-year">Saison</label>
					<select
						id="nr-j-year"
						value={state.year}
						onChange={(e) => onPatchParams({ year: e.target.value })}
					>
						{AVAILABLE_YEARS.map((y) => (
							<option key={y} value={y}>{y}</option>
						))}
					</select>
				</div>
				<MultiSelectField
					id="nr-j-liccat"
					label="Catégorie licence"
					options={playerLicenceCategories}
					selectedValues={state.playerLicenceCategories}
					onChange={(values) => onPatchParams({ licCats: serializeMultiFilter(values) })}
					placeholderAll="Toutes"
				/>
				<MultiSelectField
					id="nr-j-lictype"
					label="Type licence"
					options={playerLicenceTypes}
					selectedValues={state.playerLicenceTypes}
					onChange={(values) => onPatchParams({ licTypes: serializeMultiFilter(values) })}
				/>
				<MultiSelectField
					id="nr-j-club"
					label="Club"
					options={playerClubs}
					selectedValues={state.playerClubs}
					onChange={(values) => onPatchParams({ pclubs: serializeMultiFilter(values) })}
				/>
				<div className="new-results-field">
					<label htmlFor="nr-j-minmanche">Nb min manche</label>
					<select
						id="nr-j-minmanche"
						value={state.playerMinManches || '0'}
						onChange={(e) => onPatchParams({
							minManches: e.target.value === '0' ? null : e.target.value,
							minParties: null,
						})}
					>
						{minManchesOptions.map((count) => (
							<option key={count} value={count}>{count}</option>
						))}
					</select>
				</div>
				<PlayerSearchPaginationRow
					searchId="nr-search"
					pageSizeId="nr-j-psize-inline"
					localSearch={localSearch}
					onLocalSearchChange={onLocalSearchChange}
					pageSize={state.playerPageSize}
					effectivePage={effectivePlayerPage}
					totalPages={totalPlayerPages}
					onPatchParams={onPatchParams}
				/>
			</div>
		</>
	);
}

export function CareerSearchToolbar({
	localSearch,
	onLocalSearchChange,
	pageSize,
	effectivePage,
	totalPages,
	onPatchParams,
}) {
	return (
		<div className="new-results-toolbar new-results-toolbar--career">
			<PlayerSearchPaginationRow
				searchId="nr-c-search"
				pageSizeId="nr-c-psize-inline"
				localSearch={localSearch}
				onLocalSearchChange={onLocalSearchChange}
				pageSize={pageSize}
				effectivePage={effectivePage}
				totalPages={totalPages}
				onPatchParams={onPatchParams}
			/>
		</div>
	);
}

function PlayerSearchPaginationRow({
	searchId,
	pageSizeId,
	localSearch,
	onLocalSearchChange,
	pageSize,
	effectivePage,
	totalPages,
	onPatchParams,
}) {
	return (
		<div className="new-results-search-pagination-row">
			<div className="new-results-field new-results-search-wrap">
				<SearchIcon className="new-results-search-icon" aria-hidden />
				<input
					id={searchId}
					type="search"
					aria-label="Nom ou n° de licence"
					placeholder="Nom ou n° de licence"
					value={localSearch}
					onChange={(e) => onLocalSearchChange(e.target.value)}
				/>
			</div>
			<div className="new-results-pagination-inline">
				<div className="new-results-pagination-size">
					<select
						id={pageSizeId}
						aria-label="Vues par page"
						value={pageSize}
						onChange={(e) => onPatchParams({
							psize: e.target.value,
							ppage: null,
						})}
					>
						{PLAYER_PAGE_SIZE_OPTIONS.map((size) => (
							<option key={size} value={size}>{size}</option>
						))}
					</select>
				</div>
				<button
					type="button"
					className="new-results-pagination-btn"
					onClick={() => onPatchParams({ ppage: effectivePage - 1 })}
					disabled={effectivePage <= 1}
				>
					Précédent
				</button>
				<span className="new-results-pagination-meta">
					Page {effectivePage}/{totalPages}
				</span>
				<button
					type="button"
					className="new-results-pagination-btn"
					onClick={() => onPatchParams({ ppage: effectivePage + 1 })}
					disabled={effectivePage >= totalPages}
				>
					Suivant
				</button>
			</div>
		</div>
	);
}
